import classNames from 'classnames';
import { capitalizeWord } from '../../../utils';
import type { IconClassName} from '../../generic';
import { FeatureFlagRequired, icons, IconText } from '../../generic';
import type { AddDependencyTab } from './types';
import { ARCHIVE_AND_LICENSE_UPLOAD } from '../../../../shared/featureFlags/flagNames';

type AddDependencyNavProps = {
  activeTab: AddDependencyTab;
  onNavClick: (tab: AddDependencyTab) => void;
};

const AddDependencyNav = ({ activeTab, onNavClick }: AddDependencyNavProps) =>
  <div className="add-dependency-nav row">
    <FeatureFlagRequired flagName={ARCHIVE_AND_LICENSE_UPLOAD}>
      <AddDependencyNavItem
        isActive={activeTab === 'upload'}
        tab="upload"
        icon={icons.zipFile}
        onNavClick={() => onNavClick('upload')}
      />
    </FeatureFlagRequired>
    <AddDependencyNavItem
      isActive={activeTab === 'search'}
      tab="search"
      icon={icons.search}
      onNavClick={() => onNavClick('search')}
    />
    <AddDependencyNavItem
      isActive={activeTab === 'create'}
      tab="create"
      icon={icons.edit}
      onNavClick={() => onNavClick('create')}
    />
  </div>;

type AddDependencyNavItemProps = {
  isActive: boolean;
  tab: AddDependencyTab;
  icon: IconClassName;
  onNavClick: () => void;
};

const AddDependencyNavItem = ({ isActive, tab, icon, onNavClick }: AddDependencyNavItemProps) =>
  <div className={classNames('nav-item', {
    'nav-item--active': isActive,
  })}>
    <button type="button" onClick={onNavClick}>
      <IconText
        icon={icon}
        text={capitalizeWord(tab)}
      />
    </button>
  </div>;

export default AddDependencyNav;
